// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"5637c54a","82":"4bfbc524","148":"675a2528","175":"cef61445","313":"8963ed49","351":"058d38fd","453":"0b781a21","677":"ac760f34","726":"8b1e5375","872":"365994f3","898":"0d9ebeac"}[chunkId] + ".chunk.js";
};